import { Validator } from '../../../core/Types';

export const UserGroupValidator: Validator[] = [
    {
        name: "name",
        required: true,
        maxLength: 50
    }
 ];